import { AwsDocument, IAwsDocumentDataSource } from "@/models/base/aws-document";

export class AwsDocumentState {
	public toRemoveDocs:AwsDocument[] =  [];
	public toAddFiles:File[] =  [];
	public documents:AwsDocument[] = [];
	public uploading:boolean = false;

	public dataSource:IAwsDocumentDataSource;

	public constructor(dataSource:IAwsDocumentDataSource, documents:AwsDocument[]){
		this.dataSource = dataSource;
		this.documents = documents;
	}

	public async save(){
		this.uploading = true;
		try{

			for (let toRemoveDoc of this.toRemoveDocs){
				await this.dataSource.deleteDocument(toRemoveDoc);
			}
			for (let toAddFile of this.toAddFiles){
				await this.dataSource.addDocument(toAddFile);
			}
		}catch(err){
		}
		this.uploading = false;
	}
}